import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { StepControls } from "../StepControls";
import { RenderFormFields } from "src/components/RenderFormFields";
import { DESCRIPTION_FIELD } from "../constants/fields";
import { registrationTitlesTrns } from "../trns";
import { StepControlsProps } from "../types";

interface Props extends StepControlsProps {}
export const BriefInfo: FC<Props> = ({ ...stepControlsProps }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-5 md:gap-10">
        <h2 className="font-semibold">{t(registrationTitlesTrns.briefInfo)}</h2>

        <div className="flex flex-col lg:flex-row justify-center items-center w-full gap-3">
          <RenderFormFields fields={DESCRIPTION_FIELD} />
        </div>
      </div>
      <StepControls {...stepControlsProps} />
    </div>
  );
};
